import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ExternalLinkIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth={svgProps.strokeWidth ?? "1.5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 7V1h-6M21 1 7.67 14.33M10.33 5h-8A1.33 1.33 0 0 0 1 6.33v13.34A1.33 1.33 0 0 0 2.33 21h13.34A1.33 1.33 0 0 0 17 19.67v-8" />
    </SVG>
  );
};
